import { useState } from 'react';
export default function useOffsetPagination({
  pageSize,
}: {
  pageSize: number;
}) {
  const [offset, setOffset] = useState(0);
  const nextPage = () => {
    setOffset((prev) => prev + pageSize);
  };
  const previousPage = () => {
    setOffset((prev) => Math.max(0, prev - pageSize));
  };
  const reset = () => {
    setOffset(0);
  };
  return {
    limit: pageSize,
    offset,
    setOffset,
    nextPage,
    previousPage,
    reset,
  };
}
